import styled, { css } from 'styled-components';
import Icon from '../Icon';

export const PrevIcon = styled(Icon)`
  ${() => css`
    transform: rotate(90deg);
  `}
`;

export default PrevIcon;
